export function useOnWheellLock(e) {
  e.stopPropagation(); // 阻止事件冒泡
  const target = e.currentTarget as HTMLElement;
  const isAtTop = target.scrollTop === 0 && e.deltaY < 0;
  const isAtBottom =
    target.scrollHeight - target.scrollTop === target.clientHeight &&
    e.deltaY > 0;

  if (isAtTop || isAtBottom) {
    e.preventDefault(); // 阻止默认行为，防止穿透到父级
  }
}

export function useOnTouchMovellLock(e: Event) {
  e.stopPropagation(); // 阻止事件冒泡
  const target = e.currentTarget as HTMLElement;
  const isAtTop = target.scrollTop === 0;
  const isAtBottom =
    target.scrollHeight - target.scrollTop === target.clientHeight;

  if (isAtTop || isAtBottom) {
    e.preventDefault(); // 阻止默认行为，防止穿透到父级
  }
}
